import Vue from 'vue'
var moment = require('moment')//for get time

export default {
  apiPrefix: '/api/v2/sites',
  apiPrefixV3: '/api/v3/sites',
  // FILTER - category
  // USE 1 - Get only older logs             - targetLogId={{firstLogId}}
  // USE 2 - Get only newer logs             - targetLogId={{lastLogId}}, toGetNewLogs=true
  // USE 3 - Get logs with time (only older) - targetLogId={{firstLogId}}, stime={{start time}}, etime={{end time}}
  // USE 4 - Get logs with time              - stime={{start time}}, etime={{end time}}
  getSiteActivityLogs: function ({siteId, stime, etime, targetLogId, toGetNewLogs, eventTypes, siteTimezone, logPeriod}) {
    let apiDetailPath = this.apiPrefix + `/${siteId}/activity_logs`
    // OPTION 1 - limit total event to 50
    let query = `?limit=50`
    // OPTION 2 - category
    if (eventTypes) query += `&filter=log.desc_id,${eventTypes}`
    // OPTION 3 - to retrieve ONLY logs not yet retrieved
    if (targetLogId) {
      if (toGetNewLogs) {
        query += `&dir=asc&sort=id`
        query += `&filter=log.id,${targetLogId},gt`
      }
      else {
        query += `&dir=desc&sort=id`
        query += `&filter=log.id,${targetLogId},lt`
      }
    }
    else {
      // 테스트결과 logid로 sorting하는게 훨씬 속도가 빨라서 변경함.
      if (etime) query += `&dir=desc&sort=id`
      else query += `&dir=desc&sort=id&filter=log.id,0,gt`
      // query += '&dir=desc&sort=log.created'
    }
    // OPTION 4 - stime (UTC) - e.g. 2020-05-12 05:00:00 gte = ~ 이상

    // ********************************** 여기서 Activity log 기간 설정하기! 
    let period = 30
    if (logPeriod) period = logPeriod
    // 사이트 타임존으로 색깔 입히기
    let nowWithSiteTimezone = moment.tz(siteTimezone)
    // ??일전 00:00:00 으로 변경
    let nowBefore30days = nowWithSiteTimezone.hours(0).minutes(0).seconds(0).hours(-24*period)
    // 사이트 타임존기준으로 UTC시간 구하기
    stime = nowBefore30days.tz('UTC').format('YYYY-MM-DD HH:mm:ss')
    if (stime) query += `&filter=log.created,${stime},gte`
    // ********************************** 여기서 Activity log 기간 설정하기! 

    // OPTION 5 - etime (UTC) - e.g. 2020-05-14 05:00:00 lte = ~ 이하 
    if (etime) query += `&filter=log.created,${etime},lt`

    // ACTION
    return Vue.http.get(Vue.env.apiPath + apiDetailPath + query, Vue.auth.getBearerHeader())
  },
  getDeviceActivityLogs: function ({siteId, stime, deviceId, toGetNewLogs, etime, eventTypes, siteTimezone, targetLogId, limit}) {
    let apiDetailPath = this.apiPrefix + `/${siteId}/activity_logs`
    
    // REQUIRE 1 - limit defaults to 50, use the provided value
    limit = Number.isInteger(limit) ? limit : 50;
    let query = `?limit=${limit}`

    // REQUIRE 2 - device Id
    if (!deviceId) return
    query += `&filter=log.device_id,${deviceId}`

    // OPTION 1 - category
    if (eventTypes) query += `&filter=log.desc_id,${eventTypes}`

    // OPTION 2 - to retrieve ONLY logs not yet retrieved
    if (targetLogId) {
      if (toGetNewLogs) {
        query += `&dir=asc&sort=id`
        query += `&filter=log.id,${targetLogId},gt`
      }
      else {
        query += `&dir=desc&sort=id`
        query += `&filter=log.id,${targetLogId},lt`
      }
    }
    else {
      // 테스트결과 logid로 sorting하는게 훨씬 속도가 빨라서 변경함.
      if (etime) query += `&dir=desc&sort=id`
      else query += `&dir=desc&sort=id&filter=log.id,0,gt`
      // query += '&dir=desc&sort=log.created'
    }

    // OPTION 3 - stime (UTC) - e.g. 2020-05-12 05:00:00 gte = ~ 이상
    if (stime) {
      const localTime = moment.tz(stime, siteTimezone);
      const utcTime = localTime.clone().tz('UTC').format('YYYY-MM-DD HH:mm:ss');
      query += `&filter=log.created,${utcTime},gte`
    }

    // OPTION 4 - etime (UTC) - e.g. 2020-05-14 05:00:00 lte = ~ 이하 
    if (etime) {
      const localTime = moment.tz(etime, siteTimezone);
      const utcTime = localTime.clone().tz('UTC').format('YYYY-MM-DD HH:mm:ss');
      query += `&filter=log.created,${utcTime},lt`
    }

    // ACTION
    return Vue.http.get(Vue.env.apiPath + apiDetailPath + query, Vue.auth.getBearerHeader())
  },
  getDevicePlaybackActivityLogs: function ({siteId, deviceId, eventTypes, siteTimezone, etime}) {
    let apiDetailPath = this.apiPrefixV3 + `/${siteId}/activity-logs/search-with-thumbnail-urls`
    let data = {
      "suppress_shard_failures": true,
      "query": { "bool": { "filter": [] } }
    }

    // size
    data.size = 100

    // device ID
    data.query.bool.filter.push({ "term": { "device_id": deviceId } })

    // sort
    data.sort = [
      { "source_event_time": { "order": "desc" } },
      { "created_at": { "order": "desc" }},
    ]

    // event type
    if (eventTypes?.length) {
      data.query.bool.filter.push({ "terms": { "item_id": eventTypes } })
    }

    return Vue.http.post(Vue.env.apiPath + apiDetailPath, data, Vue.auth.getBearerHeader())
  },
  getSiteActivityLogAudioUrl: function ({siteId, logId}) {
    let apiDetailPath = this.apiPrefix + `/${siteId}/log/activities/${logId}/audio_signed_url`
    return Vue.http.get(Vue.env.apiPath + apiDetailPath, Vue.auth.getBearerHeader())
  },
  getSiteActivityLogAudioUrlV2: function ({siteId, logId}) {
    let apiDetailPath = this.apiPrefixV3 + `/${siteId}/activity-logs/${logId}/audio-url`
    return Vue.http.get(Vue.env.apiPath + apiDetailPath, Vue.auth.getBearerHeader())
  },
  getSiteActivityLogsCategory: function ({siteId}) {
    let apiDetailPath = this.apiPrefixV3 + `/${siteId}/activity-log-categories`
    return Vue.http.get(Vue.env.apiPath + apiDetailPath, Vue.auth.getBearerHeader())
  },
  getSiteActivityLogsSearch: function ({siteId, type, eventTypes, logPeriod, targetLogId, siteTimezone, etime, stime: overrideStime, ai, device_id, partition_numbers}) {
    let apiDetailPath = this.apiPrefixV3 + `/${siteId}/activity-logs/search-with-thumbnail-urls`
    let data = {
      "suppress_shard_failures": true,
      "query": {
        "bool": {
          "filter": [
            // { "term": { "device_id": 180944 } },
            // { "terms": { "item_id": [32041, 32076] } }, // ai
            // { "terms": { "item_id": [ 32041 ] } }, // relay
            // {
            //  "term": { 
            //    "summary_entity_ids.motion": "person",
            //    "summary_entity_ids.static": "vihecle"
            //  }
            // },
            // {
            //  "range": {
            //    "event_time": {
            //      "gte": "2025-07-01T00:00:00Z",
            //      "lte": "2025-07-30T23:59:59Z"
            //    }
            //  }
            // }
          ]
        }
      },
      // "aggs": {
      //   "events_per_day": {
      //     "date_histogram": {
      //       "field": "event_time",
      //       "calendar_interval": "day",
      //       "format": "yyyy-MM-dd"
      //     }
      //   }
      // }
    }

    // size
    data.size = 50

    // ********************************** 여기서 Activity log 기간 설정하기!
    let period = 30
    if (logPeriod) period = logPeriod

    // 사이트 타임존 기준 시간 계산
    let nowWithSiteTimezone = moment.tz(siteTimezone)
    let startOfTargetDay = nowWithSiteTimezone.clone().startOf('day').subtract(period, 'days')
    let stime = startOfTargetDay.clone().tz('UTC').format('YYYY-MM-DDTHH:mm:ss[Z]')

    // range 필터 하나로 처리
    // stime - 과거 어디부터 검색할 건지
    // etime - 최근 어디까지 검색할 건지 (보통은 안넣고 달력에서 날짜 선택시에만 넣음)
    let rangeFilter = { "source_event_time": { gte: overrideStime || stime } }
    // ********************************** 여기서 Activity log 기간 설정하기!

    // 1. 최초 로그 로드 시
    if (type === "now") {
      data.sort = [
        { "source_event_time": { "order": "desc" } },
        { "created_at": { "order": "desc" }},
      ]

      if (etime) {
        rangeFilter.source_event_time.lte = etime
      }
    }
    // 2. 스크롤 업
    else if (type === "newer") {
      data.sort = [
        { "source_event_time": { "order": "asc" } },
        { "created_at": { "order": "asc" }},
      ]
      if (targetLogId) data.search_after = targetLogId
    }
    // 3. 스크롤 다운
    else if (type === "older") {
      data.sort = [
        { "source_event_time": { "order": "desc" } },
        { "created_at": { "order": "desc" }},
      ]
      if (targetLogId) data.search_after = targetLogId

    }
    // 4. 달력에서 특정 날짜 선택
    else if (type === "some") {
      data.sort = [
        { "source_event_time": { "order": "desc" } },
        { "created_at": { "order": "desc" }},
      ]

      if (etime) {
        rangeFilter.source_event_time.lte = etime
      }
    }

    // 이벤트 타입 필터
    if (eventTypes?.length) {
      data.query.bool.filter.push({ "terms": { "item_id": eventTypes } })
    }

    // AI 필터
    // AI 태그는 video event에만 해당되므로, 비디오가 아닌 이벤트는 AI 필터와 무관하게 통과시켜야 함
    // 조건: (AI 태그 매칭) OR (비디오가 아닌 이벤트)
    if (Array.isArray(ai) && ai.length) {
      const selectedKeys = ai
        .filter(item => item.checked)
        .map(item => item.key)

      if (selectedKeys.length) {
        // video event desc_ids
        const videoItemIds = [30011,30305,31223,31085,32033,32041,32042,32054,32076,32077,32037,30022,31225,30021,31226]

        if (!data.query.bool.should) {
          data.query.bool.should = []
        }

        // 1) AI 태그가 매칭되는 이벤트
        data.query.bool.should.push(
          { "terms": { "summary_entity_ids.static": selectedKeys } },
          { "terms": { "summary_entity_ids.motion": selectedKeys } }
        )
        // 2) 비디오가 아닌 이벤트는 그대로 통과
        data.query.bool.should.push(
          { "bool": { "must_not": [{ "terms": { "item_id": videoItemIds } }] } }
        )
        data.query.bool.minimum_should_match = 1
      }
    }

    // Device 필터
    // device 기반이 아닌 이벤트(arming 등)는 device 필터와 무관하게 통과시켜야 함
    // 조건: (선택된 device) OR (device 기반이 아닌 이벤트)
    if (Array.isArray(device_id) && device_id.length) {
      // arming/disarming/schedule 이벤트만 device와 무관 (network online/offline은 device 이벤트)
      const nonDeviceItemIds = [30001,30003,31065,31188,31189,31066,31067,31068,30002,30004,31062,31063,31064,32036,32035]

      data.query.bool.filter.push({
        "bool": {
          "should": [
            { "terms": { "device_id": device_id } },
            { "terms": { "item_id": nonDeviceItemIds } }
          ],
          "minimum_should_match": 1
        }
      })
    }

    // Partition 필터 (partition_number가 없는 릴레이 등도 포함)
    if (Array.isArray(partition_numbers) && partition_numbers.length) {
      data.query.bool.filter.push({
        "bool": {
          "should": [
            { "terms": { "partition_number": partition_numbers } },
            { "bool": { "must_not": [{ "exists": { "field": "partition_number" } }] } }
          ],
          "minimum_should_match": 1
        }
      })
    }

    // range 선언
    data.query.bool.filter.push({ "range": rangeFilter })

    return Vue.http.post(Vue.env.apiPath + apiDetailPath, data, Vue.auth.getBearerHeader())
  },
  getSiteDeviceActivityLogsSearch: function ({siteId, deviceId, type, eventTypes, logPeriod, targetLogId, siteTimezone, etime}) {
    if (!deviceId) return
    
    let apiDetailPath = this.apiPrefixV3 + `/${siteId}/activity-logs/search-with-thumbnail-urls`

    let data = {
      "query": {
        "bool": {
          "filter": []
        }
      },
    }

    // 디바이스 ID 필터 추가
    if (deviceId) {
      data.query.bool.filter.push({ "term": { "device_id": deviceId } })
    }

    // size
    data.size = 30

    // ********************************** 여기서 Activity log 기간 설정하기!
    let period = 30
    if (logPeriod) period = logPeriod

    // 사이트 타임존 기준 시간 계산
    let nowWithSiteTimezone = moment.tz(siteTimezone)
    let startOfTargetDay = nowWithSiteTimezone.clone().startOf('day').subtract(period, 'days')
    let stime = startOfTargetDay.clone().tz('UTC').format('YYYY-MM-DDTHH:mm:ss[Z]')

    // range 필터 하나로 처리
    // stime - 과거 어디부터 검색할 건지
    // etime - 최근 어디까지 검색할 건지 (보통은 안넣고 달력에서 날짜 선택시에만 넣음)
    let rangeFilter = { "source_event_time": { gte: stime } }
    // ********************************** 여기서 Activity log 기간 설정하기!

    // 1. 최초 로그 로드 시
    if (type === "now") {
      data.sort = [
        { "source_event_time": { "order": "desc" } },
        { "created_at": { "order": "desc" }},
      ]
    }
    // 2. 스크롤 업
    else if (type === "newer") {
      data.sort = [
        { "source_event_time": { "order": "asc" } },
        { "created_at": { "order": "asc" }},
      ]
      if (targetLogId) data.search_after = targetLogId
    }
    // 3. 스크롤 다운
    else if (type === "older") {
      data.sort = [
        { "source_event_time": { "order": "desc" } },
        { "created_at": { "order": "desc" }},
      ]
      if (targetLogId) data.search_after = targetLogId

    }
    // 4. 달력에서 특정 날짜 선택
    else if (type === "some") {
      data.sort = [
        { "source_event_time": { "order": "desc" } },
        { "created_at": { "order": "desc" }},
      ]

      if (etime) {
        rangeFilter.source_event_time.lte = etime
      }
    }

    // 이벤트 타입 필터
    if (eventTypes?.length) {
      data.query.bool.filter.push({ "terms": { "item_id": eventTypes } })
    }

    // range 선언
    data.query.bool.filter.push({ "range": rangeFilter })


    return Vue.http.post(Vue.env.apiPath + apiDetailPath, data, Vue.auth.getBearerHeader())
  },
}
